import { filter, isEmpty, keys, reduce } from 'lodash'

import { formatDescriptorOriginField } from '../utils'

const computeJsonDescriptorHighlights = (prefix, value) =>
  reduce(
    value,
    (acc, descriptor, index) => {
      const parsedDescriptor = JSON.parse(descriptor)
      const descriptorKeys = keys(parsedDescriptor)

      return {
        ...acc,
        ...reduce(
          filter(descriptorKeys, key => !isEmpty(parsedDescriptor?.[key])),
          (result, key) => ({
            ...result,
            [formatDescriptorOriginField(prefix, index, key)]:
              parsedDescriptor[key],
          }),
          {},
        ),
      }
    },
    {},
  )

export default computeJsonDescriptorHighlights
